module.exports = __webpack_public_path__ + "static/media/4522.1b711f9c.jpg";